<!--Vista de login de usuarios-->
<template>
  <v-container fluid class="loginContainer primary">
    <v-row justify="center" align="center" class="loginWrapper">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="11" sm="7" md="5" lg="4" xl="3">
            <v-card class="px-8 pt-10">
              <v-form v-on:submit.prevent="validate" ref="form" v-model="valid" lazy-validation>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <h1 class="display-2 font-weight-bold">Inicio de sesión</h1>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      ref="emailInput"
                      prepend-icon="fas fa-user"
                      v-model.trim="user.email"
                      :rules="emailRules"
                      label="Correo electrónico"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model.trim="user.password"
                      prepend-icon="fas fa-lock"
                      :append-icon="showPass ? 'visibility' : 'visibility_off'"
                      :rules="passwordRules"
                      :type="showPass ? 'text' : 'password'"
                      name="password"
                      label="Contraseña"
                      hint="Debe incluir al menos 8 caracteres."
                      counter
                      @click:append="showPass = !showPass"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="center" class="mb-3">
                      <v-btn
                        :loading="loading"
                        type="submit"
                        :disabled="!valid"
                        color="accent"
                        block
                        large
                        class="black--text font-weight-bold"
                      >Iniciar Sesión</v-btn>
                    </v-row>
                    <v-row justify="center" class="text-center">
                      <v-col cols="11" md="10" xl="9">
                        <p class="subtitle-1">
                          ¿Aún no formas parte de WeChamber? Regístrate
                          <span
                            class="secondary--text font-weight-bold"
                            id="signInText"
                            @click="signIn()"
                          >Aquí.</span>
                          <!--
                          <v-dialog v-model="dialog" persistent max-width="700">
                            <template v-slot:activator="{ on }">
                              <span
                                class="secondary--text font-weight-bold"
                                id="signInText"
                                v-on="on"
                              >Aquí.</span>
                            </template>
                            <select-type-user-card></select-type-user-card>
                          </v-dialog>-->
                          <!--
                            <span
                            v-if="this.isEmpty(this.currentTier)"
                            class="secondary--text font-weight-bold"
                            id="signInText"
                            @click="signIn()"
                          >Aquí.</span>

                          <v-dialog v-else v-model="dialog" persistent max-width="290">
                            <template v-slot:activator="{ on }">
                              <span
                                class="secondary--text font-weight-bold"
                                id="signInText"
                                v-on="on"
                              >Aquí.</span>
                            </template>
                            <v-card>
                              <v-card-title class="headline font-weight-bold">Importante</v-card-title>
                              <v-card-text>Es importante que el correo registrado sea correcto, debido a que recibirá información sobre de sus afiliaciones.</v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="red darken-1" text @click="dialog = false">Regresar</v-btn>
                                <v-btn color="blue darken-1" text @click="signIn()">Aceptar</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                            -->
                        </p>
                        <!-- RECUPERAR CONTRASEÑA -->
                        <p
                          class="secondary--text font-weight-bold pointer"
                          @click="passwordRecover()"
                        >¿Olvidaste tu contraseña?</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" class="mt-10">
          <v-col cols="2" sm="3" md="3" lg="4" xl="3">
            <v-divider color="white"></v-divider>
          </v-col>
          <v-col cols="6" sm="4" md="3" lg="3" xl="2">
            <v-row justify="center">
              <v-img src="@/assets/logo-WC.png" width="100%" height="auto"></v-img>
            </v-row>
          </v-col>
          <v-col cols="2" sm="3" md="3" lg="4" xl="3">
            <v-divider color="white"></v-divider>
          </v-col>
        </v-row>
      </v-col>
      <v-dialog v-if="!isEmpty(currentTier)" v-model="dialogAfiliado" persistent max-width="290">
        <v-card>
          <v-card-title class="headline font-weight-bold">Importante</v-card-title>
          <v-card-text>Es necesario crear una cuenta para afiliarte a cualquier organización. Será en este correo donde te haremos llegar los recordatorios y notificaciones de tu afiliación.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAfiliado = false">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
//Validaciones
import { validations } from "@/helpers/validations.js";
import { mapActions, mapState, mapMutations } from "vuex";
import selectTypeUserCard from "@/components/landing/select-type-user-card.vue";

export default {
  components: { selectTypeUserCard },
  data: () => ({
    loading: false,
    dialog: false,
    dialogAfiliado: false,
    valid: true,
    emailRules: validations.emailValidation(),
    showPass: false,
    passwordRules: validations.generalFValidation({
      name: "contraseña",
      required: true,
      minLength: 8
    }),

    user: {
      email: "",
      password: ""
    }
  }),
  computed: {
    ...mapState("affiliation", ["currentTier"]),
    ...mapState("plan", ["currentPlan"]),
    ...mapState("user", ["isAdmin"]),
    admin() {
      return this.isAdmin;
    }
  },
  methods: {
    ...mapActions("user", ["login"]),
    ...mapMutations("notifications", ["show"]),
    ...mapMutations("affiliation", ["clearTier"]),
    async validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        let role = await this.login(this.user);
        if (role === false) {
          this.show({
            text: "Usuario o contraseña incorrecta, vuelva a intentarlo.",
            color: "error"
          });
          this.$refs.emailInput.focus();
        } else if (role == "ORGANIZER") {
          this.$router.push("/dashboard/inicio");
        } else if (role == "LITE_ORGANIZER") {
          this.$router.push("/dashboard/lite");
        } else if (role == "ATTENDEE" && !this.isEmpty(this.currentTier)) {
          this.$router.push(`/afiliaciones/${this.currentPlan.id}/checkout`);
        } else if (role == "ADMIN") {
          this.$router.push(`/dashboard/FhIP5j93934HnVYRAwU66Osbw7jQP98u4z61zTx3n79JmLChBbrw6`);
        }
        else {
          this.$router.push({ name: "home" });
        }
        this.loading = false;
      }
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    signIn() {
      if (!this.isEmpty(this.currentTier)) {
        this.$router.push("/registro/afiliado");
      } else {
        this.$router.push("/registro/organizacion");
      }
    },
    passwordRecover() {
      this.$router.push("/recuperar-contraseña");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path != "/registro/afiliado" &&
      to.path != `/afiliaciones/${this.currentPlan.id}/checkout`
    )
      this.clearTier();

    next();
  },
  created() {
    if (!this.isEmpty(this.currentTier)) {
      this.dialogAfiliado = true;
    }
  }
};
</script>
<style scoped>
.loginContainer {
  min-height: 95vh;
  width: 100vw;
}
.loginWrapper {
  min-height: 90vh;
  width: 100vw;
}
#signInText {
  cursor: pointer;
}
</style>